import React, {useState, useEffect, useRef} from 'react';
import {Subject} from 'rxjs';
import {cloneDeep} from 'lodash';
import {currentResource} from '../../utils/utils';
import ConfirmationModal from '../ConfirmationModal/confirmationModal';

const toggleModalSubject = new Subject({
	source: null,
	ok: null,
	data: null
});

const openModalSubject = new Subject({
	source: null,
	data: null
});

const openModalResponse = openModalSubject.asObservable();

const modalResponse = toggleModalSubject.asObservable();

const UnsavedChangesModal = () => {
	const [showModal, setShowModal] = useState(false);
	const [source, setSource] = useState(null);
	const [modalData, setModalData] = useState(null);

	const subscriptionRef = useRef(null);

	useEffect(() => {
		subscriptionRef.current = openModalResponse.subscribe({
			next: ({source, data}) => {
				setShowModal(true);
				setModalData(data);
				setSource(source);
			}
		});
		return () => {
			if (subscriptionRef.current !== null) {
				subscriptionRef.current.unsubscribe();
			}
		};
	}, []);

	const onOkClick = () => {
		onModalResponse(true);
	};

	const onHide = () => {
		onModalResponse(false);
	};

	const onModalResponse = (ok) => {
		setShowModal(false);
		toggleModalSubject.next({source: source, ok: ok, data: modalData});
		setModalData(null);
		setSource(null);
	};

	return (
		<ConfirmationModal
			show={showModal}
			showButtons
			title={currentResource.common.unsavedChanges}
			description={currentResource.common.unsavedChangesDescription}
			confirmBtnTitle={currentResource.project.confirm}
			cancelBtnTitle={currentResource.project.cancel}
			onConfirmClick={onOkClick}
			onHide={onHide}
			closeTitle={currentResource.common.close}
			modalsize="small"
		/>
	);
};

const toggleUnsavedModal = (source, data = null) => {
	openModalSubject.next({
		source: source,
		data: data ? cloneDeep(data) : null
	});
};

export {modalResponse, toggleUnsavedModal};
export default UnsavedChangesModal;
